const FALLBACK_LANGUAGE = 'cs';

const MAPY_CZ_ALLOWED_LANGUAGES = [
  'cs',
  'de',
  'el',
  'en',
  'es',
  'fr',
  'it',
  'nl',
  'pl',
  'pt',
  'ru',
  'sk',
  'tr',
  'uk',
];

function sanitizeLanguage(language: string): string {
  return MAPY_CZ_ALLOWED_LANGUAGES.includes(language) ? language : FALLBACK_LANGUAGE;
}

export function mapyCzTileLayerUrl(layerId: string, language: string, apiKey: string): string {
  return `https://api.mapy.cz/v1/maptiles/${layerId}/256/{z}/{x}/{y}?apikey=${apiKey}&lang=${sanitizeLanguage(language)}`;
}

export type MapyCzTileLayer = {
  id: string;
  nameKey: string;
  tileSetId: string;
  isDefault: boolean;
  isUsedForFullZoom: boolean;
};

export const MAPY_CZ_TILE_LAYER_MIN_ZOOM = 0;
export const MAPY_CZ_TILE_LAYER_MAX_ZOOM = 19;

export const MAPY_CZ_TILE_LAYERS: readonly MapyCzTileLayer[] = [
  {
    id: 'mapycz-basic',
    nameKey: 'Map_TileLayer_MapyCzBasic',
    tileSetId: 'basic',
    isDefault: false,
    isUsedForFullZoom: false,
  },
  {
    id: 'mapycz-aerial',
    nameKey: 'Map_TileLayer_MapyCzAerial',
    tileSetId: 'aerial',
    isDefault: false,
    isUsedForFullZoom: true,
  },
  {
    id: 'mapycz-outdoor',
    nameKey: 'Map_TileLayer_MapyCzOutdoor',
    tileSetId: 'outdoor',
    isDefault: true,
    isUsedForFullZoom: false,
  },
  {
    id: 'mapycz-winter',
    nameKey: 'Map_TileLayer_MapyCzWinter',
    tileSetId: 'winter',
    isDefault: false,
    isUsedForFullZoom: false,
  },
];

export function defaultMapyCzTileLayerId(): string {
  return (MAPY_CZ_TILE_LAYERS.find((layer) => layer.isDefault) ?? MAPY_CZ_TILE_LAYERS[0])?.id ?? '';
}
